import React from "react";
import { injectIntl } from 'react-intl';
import AssetDetailsDropdown from "./asset-details-dropdown";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { displayDropdown, newActiveVideo, removeDropdown, toggleVolume, setSelectedAsset, setSelectedAssetRow } from '../../redux/actions/SVOD';
import VideoPlayer from './video-player';
import SVODStatus from '../../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../../analytics/analytics-events/constants';
import { EnvType } from "./constants";
import svodMessages from '../../locales/svod';

class HighlightItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			imageLoaded: false,
		};

		this.backgroundFadeInterval = {};
		this.videos = this.props.videos;

		this.upVolume = this.upVolume.bind(this);
		this.downVolume = this.downVolume.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.videoEnded = this.videoEnded.bind(this);
		this.triggerReport = this.triggerReport.bind(this);
		this.restartVideo = this.restartVideo.bind(this);
		this.selectAsset = this.selectAsset.bind(this);
	}

	componentDidMount() {
		this.backgroundFadeInterval = setInterval(() => {
			if (!this.state.imageLoaded) {
				let img = document.getElementById(`${this.props.label}-${this.props.videoObject._id.valueOf()}-img`);
				if (img && img.complete) {
					img.style.opacity = 1;
					this.setState({ imageLoaded: true });
				}
			}
		}, 500);
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.imageLoaded && this.state.imageLoaded) {
			clearInterval(this.backgroundFadeInterval);
		}
	}

	componentWillUnmount() {
		if (this.backgroundFadeInterval) {
			clearInterval(this.backgroundFadeInterval);
		}
	}

	handleOpen(e) {
		let videoIds = Object.keys(this.props.videos);
		let videoItem = this.videos[videoIds[0]];

		this.props.eventHandler({ data: { event_type: "opened_dropdown", type: "asset_details_dropdown", action: "opened_dropdown", asset_id: videoItem._id.valueOf(), time: Date.now() } });
		let payload = {
			video: videoItem,
			label: "Highlight"
		};
		this.props.newActiveVideo("dropdown");
		this.props.displayDropdown(payload);
		this.setState({active: false});
	}

	triggerReport() {
		this.props.setSelectedAsset(this.props.videos);

		let videoIds = Object.keys(this.props.videos);
		let videoItem = this.videos[videoIds[0]];
		if (this.props.environment === EnvType.PEACOCK || 
			this.props.environment === EnvType.APPLETV ) {
			this.props.eventHandler({ 
				data: { 
					event_type: "highlight_click", 
					asset_name: videoItem.name, 
					asset_id: videoItem._id,
					row_name: this.props.label.split("_")[0], 
					row_id: this.props.label.split("_")[1],
					page_location: `home_page`,
					time: Date.now() 
				}
			});
		} else {
			this.props.eventHandler({ data: { event_type: "asset_fullscreen_playback", action: "asset_fullscreen_playback", type: "highlight", asset_id: videoItem._id.valueOf(), time: Date.now() } });
		}

	}

	upVolume() {
		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'FALSE';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);


		this.props.toggleVolume(true);
		this.videoElement.updateVideoPlayer("volume", true);
	}

	downVolume() {
		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'TRUE';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		this.props.toggleVolume(false);
		this.videoElement.updateVideoPlayer("volume", false);
	}

	restartVideo() {
		this.props.newActiveVideo("highlight");
		this.props.removeDropdown();
		this.setState({ active: true });
	}

	videoEnded() {
		this.setState({ active: false });
	}

	selectAsset(asset) {
		this.props.setSelectedAsset(asset);
		this.props.setSelectedAssetRow(this.props.label);
	}

	render() {
				
		let videoItem = this.props.videoObject;

		let mpaa = (videoItem.content.mpaa !== undefined) ? (
			<span className="index-rating">{videoItem.content.mpaa.label}</span>
		) : (
			<span></span>
		);

		let volumeButton = (this.state.active && this.props.activeVideo === "highlight") ? (
			(this.props.volume.volume) ? (
				<button className="highlight-volume" id="highlight-vol" onClick={this.downVolume}><i className="fas fa-volume-up"></i></button>
			) : (
				<button className="highlight-volume" id="highlight-vol" onClick={this.upVolume}><i className="fas fa-volume-off"></i></button>
			)
		) : (
			<button className="highlight-volume" onClick={this.restartVideo}><i className="fa fa-repeat" ></i></button>
		);

		let title = (videoItem.images.title_image === undefined) ? (
			<p className="highlight-title">{videoItem.content.title}</p>
		) : (
			<p className="highlight-title">
				<img src={videoItem.images.title_image} alt=""/>
			</p>
		);
		
		let content = (this.state.active && !this.props.isSurveyActive && this.props.activeVideo === "highlight") ? (
			<VideoPlayer location="HIGHLIGHTVIDEO" id="highlight-vid" videoEnded={this.videoEnded} onRef={ref => this.videoElement = ref} video={videoItem} watchpage={false} {...this.props}/>
		) : (
			<img className="highlight-img" id={`${this.props.label}-${videoItem._id.valueOf()}-img`} src={videoItem.images.background} alt={videoItem.images.thumbnail} />
		);

		let renderHighlight = (environment) => {
			switch (environment) {
				case EnvType.APPLETV: {
					let thumbnailLink = "/study/showpage";
					if (videoItem.transactional) {
						thumbnailLink = "/study/transaction";
					}
					return (
						<div className="rpo-div videoItem-highlight" onClick={() => this.selectAsset(videoItem)}>	
							<Link to={thumbnailLink} onClick={this.triggerReport}>
								<img className="rpo-pic" src={videoItem.images.highlight ? videoItem.images.highlight : videoItem.images.thumbnail} />
							</Link>
						</div>
					);
				}
				case EnvType.NETFLIX: {
					if (this.props.dropdown.label !== "Highlight") {
						return (
							<div className="highlight videoItem-highlight" onClick={() => this.selectAsset(videoItem)}>
								<div className="highlight-left">
									{content}
									<span className="billboard-right">
										{volumeButton}
										{mpaa}
									</span>
								</div>
				
								<div className="highlight-right">
									{title}
									<div className="highlight-buttons">
										<Link to="/study/watch" onClick={this.triggerReport}>
											<button id="splash-info"><i className="fas fa-play fa-fw" /> {this.props.intl.formatMessage(svodMessages.play)}</button>
										</Link>
										<button id="splash-info" onClick={this.handleOpen}><i className="fas fa-info-circle" /> {this.props.intl.formatMessage(svodMessages.more_info)}</button>
									</div>
									<p className="highlight-tagline">{videoItem.content.logline}</p>
								</div>
							</div>				
						);
					} else {
						return (
							<div>
								<AssetDetailsDropdown {...this.props} />
							</div>
						);
					}
				}	

			}
		};

		return (
			<div >
				{renderHighlight(this.props.environment)}
			</div>
		);

	}
}


const mapStateToProps = (state) => ({
	dropdown: state.SVOD.dropdown,
	volume: state.SVOD.volume,
	activeVideo: state.SVOD.activeVideo,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	isSurveyActive: state.SVOD.isSurveyActive,
});


const mapDispatchToProps = (dispatch) => ({
	displayDropdown: (payload) => dispatch(displayDropdown(payload)),
	removeDropdown: () => dispatch(removeDropdown()),
	newActiveVideo: (payload) => dispatch(newActiveVideo(payload)),
	toggleVolume: (volume) => dispatch(toggleVolume(volume)),
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),	
	setSelectedAssetRow: (label) => dispatch(setSelectedAssetRow(label)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(HighlightItem));


// WEBPACK FOOTER //
// ./src/components/svod/highlight-item.jsx